export const environment = {
  production: false,
  environmentName: 'development',
  apiBaseUrl: 'https://api.lin-soft.com/api',
  debugMode: true
};